/**
  WARNING: This file is used in both server-side and client-side code.
 */

export const getClientEvironmentId = () => {
  const rawClientEnvironmentId = Number(
    process.env.NEXT_PUBLIC_CLIENT_ENVIRONMENT_ID
  );

  const clientEnvironmentId = Number.isInteger(rawClientEnvironmentId)
    ? rawClientEnvironmentId
    : 2; // `2` is for Everyset

  return clientEnvironmentId;
};

export const getThemeConfig = () => {
  const clientEnvironmentId = getClientEvironmentId();

  // `2` is for Everyset
  const themeConfig =
    clientEnvironmentId === 2 ? EVERYSET_THEME_CONFIG : EXTERNAL_THEME_CONFIG;

  return themeConfig;
};

type ClientEnvironmentThemeConfigType = {
  palette: {
    DISABLED_BLUE: string;
    BASE_INFORMATION: string;
  };
};

const EXTERNAL_THEME_CONFIG: ClientEnvironmentThemeConfigType = {
  palette: {
    DISABLED_BLUE: '#99DBFF',
    BASE_INFORMATION: '#E3F6FF',
  },
};

const EVERYSET_THEME_CONFIG: ClientEnvironmentThemeConfigType = {
  palette: {
    DISABLED_BLUE: '#A2ADE7',
    BASE_INFORMATION: '#E8EBF9',
  },
};

const defaultLogoUrl = process.env.NEXT_PUBLIC_DEFAULT_LOGO_URL;
const defaultClientName = process.env.NEXT_PUBLIC_CLIENT_NAME;

export const buildEnhancedClientEnvironment = (
  environmentFromApi: ClientEnvironment
): EnhancedClientEnvironment => {
  const isEveryset = environmentFromApi?.identifier === 'everyset';
  let favicon_logo_url = environmentFromApi?.favicon_logo_url;
  if (!favicon_logo_url) {
    favicon_logo_url = null;
  } else {
    favicon_logo_url = `${favicon_logo_url}?v=${Date.now()}`;
  }

  return {
    ...environmentFromApi,
    logo_url: environmentFromApi?.logo_url || defaultLogoUrl,
    favicon_logo_url,
    isEveryset,
    name: environmentFromApi?.name || defaultClientName,
  };
};
